import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

/**
 * Layout simple y responsive para Control de Gestión
 * Basado en SimpleMantenedorLayout pero sin procesos de permisos
 * Compatible con la estructura existente pero adaptado para Control de Gestión
 */
const SimpleControlGestionLayout = ({
  children,
  title = "Control de Gestión",
  subtitle,
  icon = <FaIcons.FaChartLine />,
  iconColor = "#667eea",
  showBackButton = false,
  breadcrumbs = []
}) => {
  const history = useHistory();

  // Hook para detectar el tamaño de ventana
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBackClick = () => {
    history.push('/control-gestion');
  };

  return (
    <>
      {/* Main content area */}
      <div
        style={{
            margin: '0',
            paddingTop: '15px',
            minHeight: '100dvh',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflowX: 'hidden'
          }}
      >

        {/* Header Section */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '15px',
          border: '1px solid #dee2e6',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '12px'
            }}>
              <div style={{
                backgroundColor: iconColor,
                color: 'white',
                width: '48px',
                height: '48px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                fontSize: '1.2rem'
              }}>
                {icon}
              </div>
              <div>
                <h1 style={{
                  fontSize: '1.75rem',
                  fontWeight: '600',
                  color: '#212529',
                  margin: '0',
                  fontFamily: 'Poppins, sans-serif'
                }}>
                  {title}
                </h1>
                {subtitle && (
                  <p style={{
                    fontSize: '1rem',
                    color: '#6c757d',
                    margin: '4px 0 0 0',
                    lineHeight: '1.4'
                  }}>
                    {subtitle}
                  </p>
                )}
              </div>
            </div>

            <Breadcrumb style={{
              margin: '0',
              backgroundColor: 'transparent',
              padding: '0'
            }}>
              <Breadcrumb.Item
                onClick={() => history.push('/control-gestion')}
                style={{
                  cursor: 'pointer',
                  color: '#007bff'
                }}
              >
                Control de Gestión
              </Breadcrumb.Item>

              {breadcrumbs.map((crumb, index) => (
                <Breadcrumb.Item
                  key={index}
                  active={index === breadcrumbs.length - 1}
                  onClick={crumb.path ? () => history.push(crumb.path) : undefined}
                  style={crumb.path ? {
                    cursor: 'pointer',
                    color: '#007bff'
                  } : {}}
                >
                  {crumb.label}
                </Breadcrumb.Item>
              ))}

              {breadcrumbs.length === 0 && (
                <Breadcrumb.Item active>{title}</Breadcrumb.Item>
              )}
            </Breadcrumb>

            {showBackButton && (
              <div style={{ marginTop: '12px' }}>
                <button
                  onClick={handleBackClick}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #dee2e6',
                    color: '#6c757d',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#adb5bd';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.borderColor = '#dee2e6';
                  }}
                >
                  <FaIcons.FaArrowLeft style={{ fontSize: '10px' }} />
                  Volver
                </button>
              </div>
            )}
          </div>

          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid #dee2e6',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            minHeight: 'calc(100vh - 200px)',
            overflow: 'auto'
          }}>
            <div style={{
              padding: '20px'
            }}>
              {children}
            </div>
          </div>

        </div>
      </>
    );
  };

  export default SimpleControlGestionLayout;
